
import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Palette } from "lucide-react";

// Email-safe colors
const EMAIL_SAFE_COLORS = [
  { name: "Black", value: "#000000" },
  { name: "Dark Gray", value: "#333333" },
  { name: "Gray", value: "#666666" },
  { name: "Light Gray", value: "#999999" },
  { name: "White", value: "#FFFFFF" },
  { name: "Red", value: "#FF0000" },
  { name: "Dark Red", value: "#990000" },
  { name: "Orange", value: "#FF9900" },
  { name: "Yellow", value: "#FFFF00" },
  { name: "Green", value: "#00FF00" },
  { name: "Dark Green", value: "#009900" },
  { name: "Blue", value: "#0000FF" },
  { name: "Dark Blue", value: "#000099" },
  { name: "Purple", value: "#9900FF" },
];

interface ColorPickerProps {
  onChange: (color: string) => void;
  currentColor?: string;
}

const ColorPicker: React.FC<ColorPickerProps> = ({
  onChange,
  currentColor = "#000000",
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="relative flex gap-1 items-center"
        >
          <Palette className="h-4 w-4" />
          <div
            className="h-3 w-3 rounded-full"
            style={{ backgroundColor: currentColor }}
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="p-2">
        <div className="grid grid-cols-7 gap-1">
          {EMAIL_SAFE_COLORS.map((color) => (
            <button
              key={color.value}
              className="h-6 w-6 rounded-full border border-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-1"
              style={{ backgroundColor: color.value }}
              onClick={() => onChange(color.value)}
              title={color.name}
            />
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ColorPicker;
